import io from "socket.io-client";
import { useEffect, useState } from "react";

//todo use env for url
const socket = io("https://hassei-ki-backend.onrender.com/");
// const socket = io("http://localhost:8081/");

function Template() {
  // Messages States
  const [messageReceived, setMessageReceived] = useState<string[]>([]);
  const [messageTotalReceived, setMessageTotalReceived] = useState("");

  useEffect(() => {
    socket.on("generateProgress", (data) => {
      console.log(data);
      setMessageReceived((prev) => [...prev, data]);
    });

    socket.on("totalItem", (data) => {
      console.log(data);
      setMessageTotalReceived(data);
    });
  }, [socket]);

  return (
    <div className="bg-[#1A132F] w-screen min-h-screen flex flex-col md:flex-row flex-1 pt-16 items-center justify-center relative">
      <div className="h-[520px] mx-3 my-5 md:m-0 overflow-scroll rounded-lg border-4 border-pink-400">
        <div className="flex w-full md:w-[820px] bg-rose-200 py-5 items-center justify-center">
          <h1>Message</h1>
        </div>
        <span className="text-lg font-exo text-slate-100 font-bold tracking-wide">
          <h2>{messageTotalReceived}</h2>
          {messageReceived.map((message, i) => (
            <li key={message + i}>{message}</li>
          ))}
        </span>
      </div>
    </div>
  );
}
export default Template;
